(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ingredients-A-to-Z"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-ingredients-a-to-z] a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (event) {
        const target = document.querySelector(anchor.getAttribute('href'));

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
